import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'bt-upload-picture',
  templateUrl: './upload-picture.component.html',
  styleUrls: ['./upload-picture.component.scss']
})
export class UploadPictureComponent implements OnInit {
  @ViewChild('avatarInputPic') avatarInputPic: any;
  @Input() avatarUrl;
  @Output() selectedFile = new EventEmitter<any>();
  // avatarUrl;
  file: File;
  filePic: File;
  sliderPicture = [];
  constructor() { }

  ngOnInit(): void {
  }
  clickOnAvatar() {
    this.avatarInputPic.nativeElement.click();
  }
  uploadAvatar(event) {
    const reader = new FileReader();
    reader.onload = (e: any) => {

      this.avatarUrl = e.target.result;
      this.selectedFile.emit({ url: this.avatarUrl, file: this.file });

    };

    this.filePic = event.target.files;

    reader.readAsDataURL(this.filePic[0]);
    this.uploadFile(event);


  }

  uploadFile(event) {
    const reader = new FileReader();
    this.file = event.target.files[0];

    let url;
    reader.onload = (e: any) => {
      url = e.target.result;
    };

    reader.readAsDataURL(this.file);

  }
}
